var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.27417,
    width: 52.5,
    height: 48.8251,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_105_271",
    transform: "translate(0.0349994) scale(0.0103333 0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_105_271",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAACv0lEQVR4nO3ay04UQRTG8VMsVEiGpcm4Alm7FxcqLtBH0Lj2AYQ3ML6AFwTRGMIjuDCKl7cQ3EqIMYiXcN84fxddkxDpnqlheqaonu+X9KYpqk8Ole7q5jMTEREREREREZFjgLPAM2AP2AcWgZHYdVUOsMBxC7HrqhRgGmjkNHondm2VAYwCX3OaDPAHcLFrrATgRUGTAR7Fri9JwNDRFQrcLLhl4Ff5aMx6kwPUgCXgwO8qHgPngfWCJjeA6Q7mHwHm/K0mFb+Bp8BwmY1eyrnQzxZFLHY4f96OJRVBO6u2DypgyMz2zOxcYN/WzeySc247ZLCff9fMylsZ/bVvZjXnXKPVoKHAyf4GjsPM7oU2eZC0bbT/S70KnO+lc26lkwL8/Mud/M4ps9xuNQcje71+0+ZedeJdBjAMPCF7wKTiF9mmoNxbHnAGeF1w0QZwq9QLDjKKV/Zc7Noqxzf7AdkeegN4SLZzEBERERERkYGGch39gXIdvYdyHb2Hch39gXId5UO5jt5CuY48ynX0mXIdfaJcx2miXEf3lOvoMeU6kodyHf2Dch0iIiIiIiJiZmbAFFl2Yw3Y9cca8By4Hru+5AETwMeAr1vvgfHY9SYJuAJsBTS56QcwGbvupABjwGYHTW7aAiZi158M4MMJmtz0KXb9SQBudNHkpoF+QIZ+R75dcP7QzGbMrG5mF8xs1p/rZA7lOo404kvBxe7njJ0tGLvaYn7lOnwjts2slvOjunPu+39j62b2LWfsjnPu2D9vUa4jiJKigUIbnbdCzczu5Jy7WzB2I++kch1HkL1W5zkAZoC6P2aBw4Kx8y3mV67DN2KqhMKullZQlQErXTT5bez6k0F3r+AXY9efFGCS7ENRqE3gcuy6kwSME3YbeQeMxa43ecA1sje6VWDHH5+BefTgExERERERERGptH8zChEEZqQBHQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListCheck);
export default __webpack_public_path__ + "static/media/list-check.33c067c4397df6dba0570dac5caf6f97.svg";
export { ForwardRef as ReactComponent };